(async function () {
  const nodes = Array.from(document.querySelectorAll('[data-swatches-ajax]'));
  if (!nodes.length) return;

  const SECTION = 'product-card-swatches'; // el handle/filename de la sección sin .liquid
  const CONCURRENCY = 4;

  const queue = nodes.slice();
  const workers = Array.from({ length: CONCURRENCY }, () => worker());
  await Promise.all(workers);

  async function worker() {
    while (queue.length) {
      const el = queue.shift();
      const handle = el.getAttribute('data-product-handle');
      if (!handle) continue;

      try {
        const url = `/products/${encodeURIComponent(handle)}?sections=${encodeURIComponent(SECTION)}`;
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) continue;

        const json = await res.json();
        const html = json[SECTION];
        if (html) el.innerHTML = html;
      } catch (e) {
        // silencio
      }
    }
  }
})();
